import {createMuiTheme} from '@material-ui/core';
import * as Colors from "../common/colors";

export const adminTheme = createMuiTheme({
    palette: {
        primary: {
            main: Colors.primary,
        },
        secondary: {
            main: Colors.secondary,
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        useNextVariants: true,
    },
    anchor: {
        main: Colors.secondary,
        selected: Colors.secondary
    },
    overrides: {
        MuiIconButton: {
            colorInherit: {
                color: Colors.secondary
            }
        },
        MuiFormControl: {
            root: {
                width: "100%"
            }
        }
    }
});